function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCitibank = function SvgCitibank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1358ed"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6 24.4c-.9.9-1.9 1.4-3 1.4-2.2 0-3.7-1.6-3.7-3.8s1.6-3.8 3.7-3.8c1 0 2 .5 2.9 1.4l.1.1L15 18c-1.2-1.4-2.5-2-4.2-2s-3.3.6-4.4 1.6c-1.4.9-2 2.5-2 4.4s.6 3.5 1.9 4.6c1.1 1 2.7 1.6 4.4 1.6s3.1-.7 4.2-2l-1.3-1.8zm2.7 3.5h2.4V16h-2.4v11.9zm12.1-2.6c-.7.4-1.3.6-1.8.6-.8 0-1.1-.4-1.1-1.3v-6.3H28V16h-2.5v-3.7L23 13.5V16h-2v2.3h2V25c0 1.8 1.1 3.1 2.7 3.1 1.1 0 1.8-.3 2.2-.5l.6-2.3h-.1zm2 2.6h2.5V16h-2.5v11.9z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3 13.9c-2.2-3.2-6-5.1-9.7-5.1-3.8 0-7.5 1.9-9.7 5.1l-.2.1h2.8c1.9-2 4.4-3 7-3s5.1 1 7 3h2.8v-.1z",
    style: {
      fill: "#ff220e",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgCitibank;